import AddressesTableItem from './AddressesTableItem'

export default AddressesTableItem
